import script from "./IOrderMenuMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./IOrderMenuMain.vue?vue&type=script&setup=true&lang=ts"

import "./IOrderMenuMain.vue?vue&type=style&index=0&id=ab7a5b2c&lang=scss"

const __exports__ = script;

export default __exports__